import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import type { TenantRosterUser } from "@bezoned/shared/types/api/tenant/tenant-roster-get.types.js";
import { Button } from "@fluentui/react-components";

type CurrentTeam = NonNullable<TenantRosterUser["currentTeam"]>;

interface RosterSwitchOfficeButtonProps {
  currentTeamId: string | undefined;
  team: TenantRosterUser["currentTeam"];
  onOfficeClick: (args: {
    teamId: CurrentTeam["id"];
    teamName: CurrentTeam["name"];
  }) => void;
}

export const RosterSwitchOfficeButton = ({
  currentTeamId,
  team,
  onOfficeClick,
}: RosterSwitchOfficeButtonProps) => {
  const handleClick32 = useStableCallback(() => {
    if (!team) {
      return;
    }

    onOfficeClick({
      teamId: team.id,
      teamName: team.name,
    });
  });

  if (!team) {
    return <span>—</span>;
  }

  if (team.id === currentTeamId) {
    return <span>{team.name}</span>;
  }

  return (
    <Button
      appearance="transparent"
      className="hover:text-bzd-purple-500 min-w-0 justify-start px-0 text-left"
      onClick={handleClick32}
      type="button"
    >
      <span className="truncate hover:underline">{team.name}</span>
    </Button>
  );
};
